module.exports = __webpack_public_path__ + "media/images/new/icons/viettel-834ad2f333e35c81484a7ceca26c7479.png";